import { authenticatedFetch } from '../../../api/request';

export default async function getDoctorPublicProfile(doctorId, setErrorMessage) {
    
    const onError = () => setErrorMessage('No fue posible obtener el perfil básico. Inténtelo de nuevo.');
    return await authenticatedFetch(`/doctor-profile-management/basic-doctor-profile/${doctorId}`, onError);
}
